var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "600",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Alias Separation" },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      }),
      _vm._v(" "),
      _vm.dialog
        ? _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  !_vm.isDepthHeight
                    ? _c("v-toolbar-title", [
                        _vm._v(
                          "\n        Separate alias " +
                            _vm._s(_vm.synonymName) +
                            "?\n      "
                        ),
                      ])
                    : _c("v-toolbar-title", [
                        _vm._v(
                          "\n        Separate depth alias " +
                            _vm._s(_vm.synonymName)
                        ),
                      ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  key: "alert",
                  staticClass: "my-0",
                  attrs: {
                    outline: "",
                    type: "error",
                    value: _vm.matchesLocationName,
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "\n        The alias name cannot be separated because it matches the location name. Please rename the location before\n        separating this alias.\n      "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              !_vm.isDepthHeight
                ? _c("v-card-text", { staticClass: "pb-0" }, [
                    _c("p", [
                      _vm._v(
                        "\n        The alias " +
                          _vm._s(_vm.synonymName) +
                          " will be created as a separate data source with no QA/QC status.\n      "
                      ),
                    ]),
                  ])
                : _c("v-card-text", { staticClass: "pb-0" }, [
                    _vm._v(
                      "\n      The alias " +
                        _vm._s(_vm.synonymName) +
                        " will be created as a separate data source with a Regular Alias. Its previously\n      assigned depth values will not\n      be changed.\n    "
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c("v-checkbox", {
                    attrs: {
                      color: "info",
                      label: "Assign to a location",
                      "persistent-hint": "",
                      hint: "The alias will automatically be assigned to an existing or new location based on its name.",
                    },
                    model: {
                      value: _vm.formObject.assignToLocation,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "assignToLocation", $$v)
                      },
                      expression: "formObject.assignToLocation",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        disabled: _vm.matchesLocationName,
                        loading: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("call_split")]),
                      _vm._v("\n        Separate\n      "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        outline: "",
                        color: "secondary",
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }